module.exports = __webpack_public_path__ + "static/media/adashi.eafb55fc.svg";